import posthog from 'posthog-js'
import { useState } from 'react'
import { type GeneratedImage2 } from '#app/routes/resources+/generated-images.js'
import { type WorkflowType, WORKFLOWS } from '#app/utils/helpers'

export function useImageDialogs() {
	const [dialogState, setDialogState] = useState({
		isImageOpen: false,
		isDetailerOpen: false,
		isUpscalerOpen: false,
		image: null as GeneratedImage2 | null,
	})

	const openDialog = (type: WorkflowType, image: GeneratedImage2) => {
		setDialogState({
			isImageOpen: type === WORKFLOWS.generateImage,
			isDetailerOpen: type === WORKFLOWS.faceDetailer,
			isUpscalerOpen: type === WORKFLOWS.upscaler,
			image,
		})

		posthog.capture('open_dialog', { workflow: type, image: image.id })
	}

	const closeDialog = (type: WorkflowType) => {
		switch (type) {
			case WORKFLOWS.generateImage:
				setDialogState((prev) => ({ ...prev, isImageOpen: false }))
				break
			case WORKFLOWS.faceDetailer:
				setDialogState((prev) => ({ ...prev, isDetailerOpen: false }))
				break
			case WORKFLOWS.upscaler:
				setDialogState((prev) => ({ ...prev, isUpscalerOpen: false }))
				break
		}
	}

	return {
		dialogState,
		openDialog,
		closeDialog,
	}
}
